import axios from 'axios';
import qs from 'qs';

const baseUrl = process.env.VUE_APP_API_URL;

export default {
  get(path, params = {}) {
    const withCredentials = path.includes('videoCookies');
    return axios.get(`${baseUrl}/${path}`, {
      params,
      paramsSerializer: () => {
        return qs.stringify(params, { arrayFormat: 'indices' });
      },
      withCredentials,
    }).then(res => res.data);
  },
  put(path, body = {}) {
    return axios.put(`${baseUrl}/${path}`, body).then(res => res.data);
  },
  post(path, body = {}, headers = {}) {
    return axios.post(`${baseUrl}/${path}`, body, { headers }).then(res => res.data);
  },
  patch(path, body = {}, headers = {}) {
    return axios.patch(`${baseUrl}/${path}`, body, { headers }).then(res => res.data);
  },
  delete(path, data) {
    return axios.delete(`${baseUrl}/${path}`, { data }).then(res => res.data);
  },
};
